import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";
import { get } from "lodash";

import { Field, FieldError, FieldLabel } from "@/components/ui/field";
import { Textarea } from "@/components/ui/textarea";

import { REQUIRED_MARK } from "./fieldClasses";

const FormTextarea = ({
  name,
  label,
  required,
  placeholder,
  rows,
  disabled,
  id,
  ...rest
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = get(errors, name);
  const inputId = id ?? name;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Field data-invalid={error ? true : undefined}>
          {label && (
            <FieldLabel
              htmlFor={inputId}
              className={required ? REQUIRED_MARK : undefined}
            >
              {label}
            </FieldLabel>
          )}
          <Textarea
            {...rest}
            id={inputId}
            placeholder={placeholder}
            rows={rows}
            disabled={disabled}
            aria-required={required || undefined}
            aria-invalid={error ? true : undefined}
            name={field.name}
            value={field.value ?? ""}
            onBlur={field.onBlur}
            onChange={e => field.onChange(e.target.value)}
          />
          <FieldError>{error?.message}</FieldError>
        </Field>
      )}
    />
  );
};

FormTextarea.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.node,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disabled: PropTypes.bool,
  id: PropTypes.string,
};

export default FormTextarea;
